module.exports = __webpack_public_path__ + "static/aws-6a448284e1d018eeeee66d48728f4321.png";